import cmp from './AiQuestion'

export default cmp
